import $ from 'jquery';
import { USE_THUMB_SIZE } from './consts/configs';
import { makeDateStr } from './utils';
const errorImageType = '600x0_65_wr';
const useImageType = '0x200_85_hr';

function toThumbBoardItemFormat(ds) {
  const dataList = ds.data;
  const refinedData = Object.prototype.toString.call(dataList) === '[object Array]' ? $.map(dataList, refineData) : [refineData(dataList)];
  return $.map(refinedData, makeThumbBoardData);
}

function makeThumbBoardData(data) {
  const thumb = data.thumbnail;
  const w = data.w;
  const h = data.h;
  return {
    ndid64: data.ndid64,
    docid: data.docid,
    docdsid: data.docdsid,
    url: thumb.url,
    w,
    h,
    dw: w,
    dh: h,
    iw: w,
    ih: h,
    info: {
      title: data.org_title.replace(/"/g, "&quot;"),
      htitle: data.title.replace(/"/g, "&quot;"),
      summary: data.contents_summary.replace(/"/g, "&quot;"),
      filesize: data.filesize,
      ow: parseInt(data.width, 10),
      oh: parseInt(data.height, 10),
      docurl: data.docurl,
      disdocurl: data.display_docurl,
      oimgurl: data.alter_imgurl,
      overcpname: data.display_collection_name.replace(/"/g, "&quot;").replace(/>/g, "&gt;"),
      cpname: data.display_cpname.replace(/"/g, "&quot;").replace(/>/g, "&gt;"),
      cpid: data.cpid,
      auth: "",
      cclc: data.ccl_commercial,
      ccld: data.ccl_derivative,
      regdate: makeDateStr(data.regdttm),
      cropfocus: getCropFocus(thumb)
    },
    errorthumb: data.errorthumb
  };
}

function getCropFocus(thumb) {
  const cropFocus = thumb.focus;
  const shouldCenterFocus = !cropFocus || cropFocus === 'noface' || cropFocus === 'none'; 
  return shouldCenterFocus ? 'center' : cropFocus;
}

function getUseThumbSize(thumb) {
  const shouldUseMoSize = USE_THUMB_SIZE === 170;
  const w = shouldUseMoSize ? thumb.mo_width : thumb.width;
  const h = shouldUseMoSize ? thumb.mo_height : thumb.height;
  return {
    w: parseInt(w, 10),
    h: parseInt(h, 10)
  };
}

function refineData(data) {
  const thumbData = data.thumbnail.data;
  const hasThumbDataInArray = thumbData.length;
  let result = null;
  let errorThumb = null;
  let defaultErrorThumb = {
    url: '//:0',
    w: '',
    h: ''
  };

  if (hasThumbDataInArray) {
    $.each(thumbData, (idx, thumb) => {
      const thumbType = thumb.type;
      if (thumbType === useImageType) {
        result = thumb;
      }
      errorThumb = errorThumb || getErrorThumbData(thumb, errorImageType);
    });
  } else {
    result = thumbData.data;
  }

  const thumbSize = getUseThumbSize(result);

  return result ? $.extend({}, data, { thumbnail: result }, { errorthumb: errorThumb || defaultErrorThumb }, thumbSize) : null;
}

function getErrorThumbData(thumb, errorImageType) {
  if (thumb.type === errorImageType) {
    return {
      url: thumb.url || '//:0',
      w: thumb.width,
      h: thumb.h
    };
  }
  return null;
}

export default toThumbBoardItemFormat;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/converter.js
 **/